import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

i18n
  .use(HttpBackend) // 懒加载翻译文件
  .use(LanguageDetector) // 浏览器语言检测
  .use(initReactI18next)
  .init({
    fallbackLng: 'zh', // 默认中文
    supportedLngs: ['en', 'zh'], // 支持语言
    ns: ['common', 'dashboard', 'recharge', 'invite', 'management', 'reserve', 'settings', 'help', 'whitepaper'], // 命名空间
    defaultNS: 'common', // 默认命名空间
    interpolation: { escapeValue: false }, // React 已转义
    backend: { 
      loadPath: '/locales/{{lng}}/{{ns}}.json', // 文件路径
      requestOptions: {
        cache: 'no-store'
      }
    }, 
    detection: { 
      order: ['localStorage', 'navigator'] // 检测顺序
    }, 
    react: { 
      useSuspense: false // 禁用Suspense加载以避免问题
    },
  });

export default i18n; 